/* RESPONSIBLE TEAM: team-proactive-support */
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default EmbercomBaseSerializer.extend({
  // By default, ember will try to singluarize the key to get the model name
  modelNameFromPayloadKey() {
    return 'proactive-support-message-filters';
  },
});
